import { useId, useState } from 'react';

import { FAQ_COLUMNS, type Faq } from './content';
import * as styles from './Faqs.css';
import { container, sectionHeading, sectionShell } from './landing.css';

const Arrow = () => (
  <svg className={styles.arrow} viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12.0967 14.591L19.7569 6.93108C19.9847 6.70306 20.2638 6.58947 20.594 6.59031C20.9242 6.59115 21.2075 6.70558 21.4439 6.93359C21.6831 7.17266 21.8027 7.45831 21.8027 7.79053C21.8027 8.12258 21.6831 8.40689 21.4439 8.64345L13.4381 16.6529C13.2478 16.8431 13.0361 16.9827 12.8029 17.0716C12.5695 17.1604 12.3341 17.2048 12.0967 17.2048C11.8595 17.2048 11.6242 17.1604 11.3908 17.0716C11.1574 16.9827 10.9456 16.8431 10.7555 16.6529L2.7269 8.62435C2.48766 8.38511 2.37223 8.10432 2.3806 7.78199C2.38898 7.45948 2.51279 7.17861 2.75203 6.93937C2.9911 6.71152 3.27331 6.59475 3.59866 6.58905C3.92385 6.58353 4.20598 6.7003 4.44505 6.93937L12.0967 14.591Z"
      fill="currentColor"
    />
  </svg>
);

const FaqItem = ({ faq }: { faq: Faq }) => {
  const [open, setOpen] = useState(false);
  const id = useId();
  const buttonId = `${id}-question`;
  const panelId = `${id}-answer`;

  return (
    <div className={styles.item} data-open={open}>
      <h3 className={styles.questionHeading}>
        <button
          type="button"
          id={buttonId}
          className={styles.summary}
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen((value) => !value)}
        >
          <span className={styles.question}>{faq.question}</span>
          <span className={styles.toggle} aria-hidden>
            <Arrow />
          </span>
        </button>
      </h3>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className={styles.panel}
        inert={!open}
      >
        <div className={styles.panelInner}>
          <div className={styles.answer}>{faq.answer}</div>
        </div>
      </div>
    </div>
  );
};

export const Faqs = () => (
  <section className={`${sectionShell} ${styles.section}`}>
    <div className={`${container} ${styles.inner}`}>
      <h2 className={sectionHeading}>
        Got a few questions?
        <br />
        We’re happy to answer them.
      </h2>
      <div className={styles.columns}>
        {FAQ_COLUMNS.map((column) => (
          <div key={column[0]?.question} className={styles.column}>
            {column.map((faq) => (
              <FaqItem key={faq.question} faq={faq} />
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);
